import { AxiosRequestConfig } from "axios";
import ApiClient from "../../services/apiClient";

export const assessmentList = (opts?: AxiosRequestConfig) =>
  ApiClient.get(`/assessment`, opts);

export const assessmentCreate = (data: any, opts?: AxiosRequestConfig) =>
  ApiClient.post("/assessment", data, opts);
